<template>
  <div>
    <baseFrame
      save-text=""
      clear-text=""
      submit-text="提交"
      :submit-loading="submitLoading"
      @submit="submitConfirm"
      @cancel="handleToPrimaryKeyList">
      <div slot="content">
        <lk-card>
          <lk-form
            ref="form"
            label-position="right"
            :model="formModel"
            :label-width="134">
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="供应商主键列表:">
                  <lk-button type="primary" @click="handleAdd">新增</lk-button>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <div class="supplierPrimaryKey" style="margin-left: 134px;">
                  <lk-table border :columns="columns" :data="formModel.tableData">
                    <template slot-scope="{ row, index }" slot="socialUnifyCreditCodeName">
                      <lk-form-item
                        :prop="'tableData.' + index + '.socialUnifyCreditCode'"
                        :label-width="0"
                        :rules="[{required: true, tigger: 'blur', message: '请输入..'},{validator: validSocialUnifyCreditCode, tigger: 'blur' }]"
                      >
                        <lk-input
                          clearable
                          placeholder="请输入"
                          @on-change="validFormItem($event, row, index)"
                          v-model.trim="row.socialUnifyCreditCode">
                        </lk-input>
                      </lk-form-item>
                    </template>
                  </lk-table>
                </div>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
    <DTPModal
      v-model="submitConfirmVisiable"
      content="供应商主键被修改，确认提交？"
      :confirmLoading="submitLoading"
      @confirm="submit"
      @handleCancel="submitConfirmVisiable = false">
    </DTPModal>
    <lk-modal
      v-model="modalVisiable"
      :mask-closable="false"
      title="选择供应商"
      width="900">
      <div class="queryContainer">
        <div class="queryItem">
          <label>供应商名称:</label>
          <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="modalQuery.name"></lk-input>
        </div>
        <div class="queryItem">
          <label>社会统一码:</label>
          <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="modalQuery.creditCode"></lk-input>
        </div>
        <div class="queryItem">
          <label>编码:</label>
          <lk-input :maxlength="100" class="item" placeholder="请输入" clearable v-model.trim="modalQuery.code"></lk-input>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr8" @click="handleModalSearch">查询</lk-button>
          <lk-button @click="clearModalQuery" class="mr8">重置</lk-button>
        </div>
      </div>
      <div style="position: relative;">
        <LoadingSpan v-show="modalLoading"></LoadingSpan>
        <lk-table
          border
          height="400"
          :columns="modalColumns"
          :data="modalTableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel">
        </lk-table>
      </div>
      <div style="margin-top: 14px; text-align: right;">
        <lk-page
          :total="modalPage.count"
          :page-size="modalPage.size"
          :current="modalPage.page"
          size="small"
          show-sizer
          show-total
          show-elevator
          @on-change="handleModalPage"
          @on-page-size-change="handleModalSize">
        </lk-page>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <span style="padding-right: 16px;">已选:{{this.tempSelection.length + this.formModel.tableData.length}}项</span>
          <lk-button @click="hideModal">取消</lk-button>
          <lk-button type="primary" class="mr" @click="pushModalData">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import toolsService from '../../services/tools';
import utils from '../../libs/utils';
import supplier from '../../services/supplier';
import DTPModal from '../../components/DTPModal';
import LoadingSpan from '../../components/LoadingSpan.vue';

export default {
  name: 'supplierPrimaryKeyAdd',
  components: {
    baseFrame,
    DTPModal,
    LoadingSpan,
  },
  data() {
    return {
      submitConfirmVisiable: false,
      submitLoading: false,
      formModel: {
        tableData: [],
        socialList: [],
      },
      formRules: {
        socialList: [
          {
            required: true,
          },
          {
            type: 'array',
            message: '请选择',
          },
        ],
        socialCode: [
          {
            required: true,
          },
        ],
      },
      columns: [
        {
          title: '编码',
          minWidth: 80,
          key: 'code',
        },
        { title: '供应商名称', key: 'name', minWidth: 116 },
        {
          title: '社会统一信用代码',
          slot: 'socialUnifyCreditCodeName',
          minWidth: 116,
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { index }) => h('lk-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                this.formModel.tableData.splice(index, 1);
                this.$Message.success('删除成功');
                this.$nextTick(() => {
                  this.formModel.tableData.forEach((item, index2) => {
                    this.$refs.form.validateField(`tableData.${index2}.socialUnifyCreditCode`);
                  });
                });
              },
            },
          }, '删除'),
        },
      ],
      enterpriseTypeList: ['', '药品经营', '药品生产', '食品（生产、经营）', '器械生产', '器械经营', '化妆品'],
      modalLoading: false,
      modalVisiable: false,
      modalQuery: {
        name: null,
        creditCode: null,
        code: null,
      },
      modalParams: {},
      modalPage: {
        page: 1,
        size: 10,
        count: 0,
      },
      tempSelection: [],
      modalTableData: [],
      modalColumns: [
        {
          title: '选择', key: 'id', type: 'selection', width: 60,
        },
        { title: '编码', key: 'code', minWidth: 116 },
        { title: '供应商名称', key: 'name', minWidth: 116 },
        { title: '社会统一码', key: 'socialUnifyCreditCode', minWidth: 116 },
        { title: '助记码', key: 'memoryCode', minWidth: 116 },
        { title: '企业法人', key: 'corporationPerson', minWidth: 116 },
        { title: '注册地址', key: 'rigistryAddress', minWidth: 116 },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTimeStr', minWidth: 116 },
        { title: '企业性质', key: 'enterpriseType', minWidth: 116 },
        {
          title: '状态',
          minWidth: 116,
          key: 'baseInfoStatus',
          render: (h, params) => h('span', params.row.status === 1 ? '启用' : '禁用'),
        },
      ],
    };
  },
  computed: {
    selectedIds() {
      const result = [];
      this.formModel.tableData.forEach((item) => {
        result.push(item.id);
      });
      return result;
    },
    tempSelectionIds() {
      const result = [];
      this.tempSelection.forEach((item) => {
        result.push(item.id);
      });
      return result;
    },
  },
  methods: {
    getModalData() {
      this.modalParams.page = this.modalPage.page;
      this.modalParams.size = this.modalPage.size;
      this.$store.commit('setDisableLoading', true);
      this.modalLoading = true;
      supplier.SupplierGeneralList(this.modalParams).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          list.forEach((item) => {
            item.originalCreditCode = item.socialUnifyCreditCode; // 保留一份原始社会统一码
            item.createTimeStr = utils.formatDate(item.createTime);
            item._checked = this.selectedIds.includes(item.id) || this.tempSelectionIds.includes(item.id);
            item._disabled = this.selectedIds.includes(item.id);

            // 企业性质
            const types = item.enterpriseType.split(',');
            item.enterpriseType = [];
            types.forEach((val) => {
              item.enterpriseType.push(this.enterpriseTypeList[val * 1]);
            });
            if (item.enterpriseType[0]) {
              item.enterpriseType = item.enterpriseType.join(',');
            } else {
              item.enterpriseType = '';
            }
          });
          this.modalTableData = list;
          this.modalPage.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
        this.modalLoading = false;
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    validFormItem(e, item, index) {
      const value = e.target.value;
      item.socialUnifyCreditCode = e.target.value;
      this.formModel.tableData[index] = item;
      this.$nextTick(() => {
        if (utils.isEmpty(value)) { // 重新触发验证
          this.$refs.form.validateField(`tableData.${index}.socialUnifyCreditCode`);
        }
      });
    },
    validSocialUnifyCreditCode(rule, value, callback) {
      // 判断是否符合规则
      if (!/^(\d|[a-z]|[A-Z]){18}$/.test(value)) {
        callback(new Error('请输入正确的社会统一信用代码'));
      } else {
        let count = 0; // 判断是否有重复的信用代码
        let originalItem = {}; // 判断是否是原始的信用代码
        this.formModel.tableData.forEach((subItem) => {
          if (subItem.socialUnifyCreditCode === value) {
            count++;
            originalItem = subItem;
          }
        });

        if (count > 1) {
          callback(new Error('列表中存在相同的社会统一信用代码'));
        } else if (value === originalItem.originalCreditCode) { // 与原始信用代码一致
          callback();
        } else {
          this.$store.commit('setDisableLoading', true);
          supplier.supplierSocialCodeCheck({
            socialCode: value,
            originType: 1, // 1基础 2首营
          }).then((res) => {
            if (res.data.status === 200) {
              if (res.data.data) {
                callback(new Error('社会统一信用代码已存在'));
              } else {
                callback();
              }
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      }
    },
    submit() {
      const params = [];
      this.formModel.tableData.forEach((item) => {
        params.push({
          supplierId: item.id,
          code: item.code,
          originalCreditCode: item.originalCreditCode, // 原社会统一码
          creditCode: item.socialUnifyCreditCode, // 新社会统一码
          name: item.name,
        });
      });
      this.submitLoading = true;
      this.$store.commit('setDisableLoading', true);
      toolsService.supplierPrimarySubmit({ operateSupplierKeyVoList: params }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          setTimeout(() => {
            this.handleToPrimaryKeyList();
          }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
      }).catch((err) => {
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    submitConfirm() {
      if (this.formModel.tableData.length === 0) {
        this.$Message.error('请先添加供应商');
        return;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          let num = 0;
          this.formModel.tableData.forEach((item) => {
            if (item.socialUnifyCreditCode === item.originalCreditCode) {
              num++;
              this.$Message.error(`供应商编码${item.code}未做任何更改，无需提交`);
            }
          });

          if (num === 0) {
            this.submitConfirmVisiable = true;
          }
        } else {
          this.$Message.error('请按照要求填写');
        }
      });
    },
    handleToPrimaryKeyList() {
      this.$router.push({
        name: 'supplierPrimaryKey',
      });
    },
    clearModalQuery() {
      this.modalQuery = {};
    },
    hideModal() {
      this.modalVisiable = false;
    },
    handleAdd() {
      this.modalVisiable = true;
      this.clearModalQuery();
      this.handleModalSearch();
    },
    handleModalSearch() {
      this.tempSelection = [];
      this.modalPage.page = 1;
      this.modalPage.size = 10;
      this.modalParams = utils.deepClone(this.modalQuery);
      this.getModalData();
    },
    pushModalData() {
      if (this.tempSelection.length === 0 && this.formModel.tableData.length === 0) {
        this.$Message.error('请选择记录');
        return;
      }

      if (this.tempSelection.length > 10) {
        this.$store.commit('setLoading', true);
        utils.timeChunk(this.tempSelection, (goods) => {
          this.formModel.tableData.push(goods);
        }, 10, () => {
          this.$store.commit('setLoading', false);
        })();
      } else {
        this.tempSelection.forEach((item) => {
          this.formModel.tableData.push(item);
        });
      }
      this.tempSelection = [];
      this.hideModal();
    },
    handleModalPage(val) {
      this.modalPage.page = val;
      this.getModalData();
    },
    handleModalSize(val) {
      this.modalPage.size = val;
      this.getModalData();
    },
    handleTempSelect(selection, row) {
      if (!this.tempSelectionIds.includes(row.id)) {
        this.tempSelection.push(row);
      }
    },
    handleTempCancel(selection, row) {
      this.tempSelection.forEach((item, index) => {
        if (item.id === row.id) {
          this.tempSelection.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.tempSelectionIds.includes(item.id) && !this.selectedIds.includes(item.id)) {
          this.tempSelection.push(item);
        }
      });
    },
    handleSelectAllCancel() {
      this.modalTableData.forEach((good) => {
        for (let i = 0, len = this.tempSelection.length; i < len; i++) {
          if (this.tempSelection[i].id === good.id) {
            this.tempSelection.splice(i, 1);
            break;
          }
        }
      });
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
</style>
